<template>
  <v-container class="mt-2">
    <v-card class="px-2">
      <v-row>
        <v-col>
          <p>Regra de Aceitação - Novo Registro</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="save">
            <v-icon small title="Create">fas fa-save</v-icon>
          </v-btn>
          <v-btn class="ml-1" small @click="$refs.form.goBack()">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <AcceptanceRuleForm ref="form" :errors="errors" :acceptance-rule="acceptanceRule"></AcceptanceRuleForm>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import {mapErrors} from "@/common/validation";
import {mapActions, mapMutations} from "vuex";
import AcceptanceRuleForm from "@/view/acceptance_rule/_acceptance_rule_form"

export default {
  components: { AcceptanceRuleForm },
  data() {
    return {
      errors: {},
      acceptanceRule: {
        code: null,
        description: null,
        minimumLives: null,
        maximumLives: null,
        active: true
      }
    };
  },
  methods: {
    ...mapActions("acceptanceRule", ["createAcceptanceRule"]),
    ...mapMutations(["toogleDialogLoading"], 'showmsg'),
    save() {
      if(!this.$refs.form.validate()) {
        return;
      }
      
      this.toogleDialogLoading(true);
      this.errors = {}

      this.createAcceptanceRule(this.$refs.form.model())
          .then(data => {
            this.$router.push(`/acceptance_rule/${data.id}/show`)
          })
          .catch((error) => {
            const { errors } = error.response.data;
            this.errors = mapErrors(this.$refs.form.model(), errors)
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
    }
  },
};
</script>


